export default __webpack_public_path__ + "static/media/tmovie.5d7d44a4.png";